import React, { useEffect, useMemo, useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";


import "./CardForm.scss"
import { Button } from "@material-ui/core";
import { PATHS } from "../../../Constants";
import { useHistory } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
import { Alert } from "react-bootstrap";

const useOptions = () => {
  const fontSize = "16px"
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#9e2146"
        }
      }
    }),
    [fontSize]
  );

  return options;
};

const CardForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const history = useHistory();
  const  [error, setError] = useState({errorCase:false, errorMessage:""});
  const [spinner, setSpinner] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setSpinner(true);

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    const payload = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement)
    });

    if (payload && payload.error) {
      setSpinner(false);
      // console.log("[PaymentMethod] Error:", payload);
      setError({ errorCase:true , errorMessage: payload.error.message })
    }
    else {
      setSpinner(false);
      // console.log("[PaymentMethod] Success:", payload);
      history.push({ pathname:PATHS.PLANS+PATHS.PURCHASE_SUMMARY, state:payload });
    }
  };

  const renderAlert = () => {
    return (
      <Alert variant="danger" className="alertMessage">
        {error.errorMessage}
      </Alert>
    );
  };

  const renderErrorUI = () => {
    return (
      <>
        <div className="errorContainer">
          {renderAlert()}
        </div>
      </>
    );
  };

  return (
    <>
    <form onSubmit={handleSubmit}>
      <div className="AddCardContainer">
        {error.errorCase ? renderErrorUI() : ""}
        <h6 className="cardDetailsHeader">Card details</h6>
        <CardElement
          options={options}
          onReady={() => {
            // console.log("CardElement [ready]");
          }}
          onChange={(event) => {
            // console.log("CardElement [change]", event);
          }}
          onBlur={() => {
            // console.log("CardElement [blur]");
          }}
          onFocus={() => {
            // console.log("CardElement [focus]");
          }}
        />
        <div className="btnWrapper">
          <Button className="addPaymentMethodBtn" type="submit" disabled={!stripe}>
            {"Add Payment Method"}
          </Button>
        </div>
      </div>
    </form>
    <Spinner showModal={spinner}></Spinner>
    </>
  );
};

export default CardForm;
